import { Badge, CopyButton, Tooltip, type BadgeProps, type MantineSize } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function CopyableBadge({
  value,
  displayValue,
  icon,
  size = 'md',
  badgeProps,
}: {
  value: string;
  displayValue?: ReactNode;
  icon: ReactNode;
  size?: MantineSize;
  badgeProps?: BadgeProps;
}) {
  return (
    <CopyButton value={value}>
      {({ copied, copy }) => (
        <Tooltip
          withArrow
          opened={copied ? true : undefined}
          label={copied ? 'Copied!' : value}
          color={copied ? 'teal' : undefined}
        >
          <Badge
            variant="default"
            size={size}
            {...badgeProps}
            classNames={{
              root: 'font-semibold normal-case cursor-pointer',
              // oxlint-disable-next-line @typescript-eslint/no-misused-spread
              ...badgeProps?.classNames,
            }}
            leftSection={
              copied ?
                <IconCheck
                  color="teal"
                  size={14}
                />
              : icon
            }
            onClick={copy}
          >
            {displayValue ?? value}
          </Badge>
        </Tooltip>
      )}
    </CopyButton>
  );
}
